<template>
  <div class="fbchatnow-container">
    <!-- do not put this within v-if v-else -->
    <button class="f-button" :class="fButtonClass" style="color: rgb(255, 255, 255);background: rgb(0, 0, 0);" @click="onCountDownSlideUp">
      <span class="f-icon"><img src="../assets/icon-custom-fb.png" alt="Facebook Chat"></span>
      <span class="f-title">Need help?</span>
    </button>
    <div class="f-box" :style="fBoxStyle">
      <button class="f-close" style="border-color: #000000;" @click="onCountDownSlideDown">x</button>
      <div id="fb-livechat-page" style="border: 3px solid rgb(0, 0, 0); min-width: 290px; min-height: 350px; width: auto; height: auto;">
        <div class="fb-page fb_iframe_widget" data-tabs="messages" data-height="350" data-width="290" data-href="https://www.facebook.com/noctorus.studio" data-small-header="true" data-adapt-container-width="false" data-hide-cover="false" data-show-facepile="false" data-show-posts="false" fb-xfbml-state="rendered" fb-iframe-plugin-query="adapt_container_width=false&amp;app_id=&amp;container_width=290&amp;height=350&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2Fnoctorus.studio&amp;locale=en_US&amp;sdk=joey&amp;show_facepile=false&amp;show_posts=false&amp;small_header=true&amp;tabs=messages&amp;width=290"></div>
      </div>
    </div>
    <div v-if="false"
      class="fb-messengermessageus"
      messenger_app_id="782732588553167"
      page_id="418381418548219"
      color="white"
      size="standard"
      style="font-size:0.6em;">
      message us at https://www.facebook.com/noctorus.studio.
    </div>
	</div>
</template>

<script>
  import FBControl from '@/controllers/FBControl'
  export default {
    data: function () {
      return {
        show: false,
        fButtonClass: 'slideUp',
        fBoxStyle: {
          overflow: 'hidden',
          height: '0px',
          padding: 0,
          margin: 0,
          display: 'none'
        },
        fCounting: 0,
        intervalSlideUp: undefined,
        intervalSlideDown: undefined,
        logged: 'not_logged',
        FB: undefined
      }
    },
    props: {
    },
    created () {
      FBControl.getFB()
      .then((FB) => {
        console.log('getting FB@!!')
        console.log(FB)
        this.FB = FB
      })
      .catch((error) => {
        console.log('no FB@!!')
        console.log(error)
      })
    },
    methods: {
      onShowToggle: function () {
        this.show = !this.show
        if (this.show) {
          this.fButtonClass = 'slideDown'
        } else {
          this.fButtonClass = 'slideUp'
        }
      },
      onCountDownSlideUp: function () {
        // on init
        this.fButtonClass = 'slideDown'
        this.fBoxStyle.display = 'block'

        // start counting up
        this.intervalSlideUp = setInterval(() => {
          this.fCounting += 15
          this.fBoxStyle.height = this.fCounting + 'px'
          if (this.fCounting >= 350) {
            this.fCounting = 350
            this.fBoxStyle.height = this.fCounting + 'px'
            if (this.intervalSlideUp) {
              clearInterval(this.intervalSlideUp)
              this.intervalSlideUp = undefined
            }
            if (this.intervalSlideDown) {
              clearInterval(this.intervalSlideDown)
              this.intervalSlideDown = undefined
            }

            // on complete
            this.fBoxStyle.overflow = 'inherit'
            return
          }
        }, 10)
      },
      onCountDownSlideDown: function () {
        // on init
        this.fBoxStyle.overflow = 'hidden'

        // start counting down
        this.intervalSlideDown = setInterval(() => {
          this.fCounting -= 15
          this.fBoxStyle.height = this.fCounting + 'px'
          if (this.fCounting < 0) {
            this.fCounting = 0
            this.fBoxStyle.height = this.fCounting + 'px'
            if (this.intervalSlideUp) {
              clearInterval(this.intervalSlideUp)
              this.intervalSlideUp = undefined
            }
            if (this.intervalSlideDown) {
              clearInterval(this.intervalSlideDown)
              this.intervalSlideDown = undefined
            }

            // on complete
            this.fBoxStyle.display = 'none'
            this.fButtonClass = 'slideUp'
            return
          }
        }, 10)
      }
    }
  }
</script>


<style lang="scss">
@import "../styles/app_setting.scss";

.fbchatnow-container {
  position: fixed;
  top: auto!important;
  bottom: 0;
  right: 1%; // 8%
  left: auto;
  z-index: 999999999;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .f-button {
    display: block;
    // float: right;
    background: #4e69a2;
    color: #fff;
    cursor: pointer;
    position: relative;
    bottom: 0;
    padding: 7.5px 15px;
    border: none;
    border-radius: 1px;
    box-shadow: 0 0 6px rgba(0,0,0,.45);
    transition: all .3s ease;
    height: 40px;
    width: auto;

    &:focus {
      outline: 0;
    }

    &.slideUp {
      opacity: 1;
      visibility: visible;
      bottom: 8px;
    }

    &.slideDown {
      opacity: 0;
      visibility: hidden;
      bottom: -40px;
    }

    span {
      font-size: 13px;
      height: 25px;
      line-height: 25px;
      vertical-align: top;
      display: inline-block;

      &.f-icon {

        img {
          margin-right: 20px;
          width: 25px!important;
          height: 25px!important;
        }

        &::before {
          content: '';
          position: absolute;
          background: rgba(255,255,255,.5);
          height: 26px;
          width: 1px;
          left: 52px;
        }
      }
    }
  }

  .f-box {
    position: relative;
    display: none;

    &.slideUp {
      display: none;
    }

    &.slideDown {
      display: block;
    }

    .f-close {
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 99;
      margin: 0;
      padding: 0;
      background: url(../assets/bg-close.png) 6px 5px no-repeat #afb4bd;
      color: transparent;
      text-indent: 999px;
      font-weight: 600;
      width: 30px;
      height: 30px;
      min-height: 30px;
      border-radius: 100%;
      line-height: 30px;
      border: 2px solid;
      box-sizing: border-box;
      min-width: inherit;
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// FBChatNow.vue?e06b7078